import { useEffect, useState } from "react";
import { useOptimizelyStore } from "stores/OptimizelyStore";
import config from "config/config";
import { appendExternalScript } from "utils/appendExternalScript/appendExternalScript";
import { useLanguage } from "contexts/LocalizationContext";
import useExtendedRouter from "hooks/useExtendedRouter";
import type { OptimizelyTransformedExperiment } from "services/optimizely/types";
import { getIncludeDraftExperiments, setIncludeDraftExperiments, shouldInsertOptimizelySnippet } from "./utils";

const {
  optimizely: { scriptUrl },
} = config;

export const useIsSupportedPage = (experiments: OptimizelyTransformedExperiment[], forceDraftExperiments: boolean) => {
  const language = useLanguage();
  const router = useExtendedRouter();

  return shouldInsertOptimizelySnippet(experiments, router, language, forceDraftExperiments);
};

export const useOptimizelySnippet = (experiments: OptimizelyTransformedExperiment[]) => {
  const { setOptimizelyLoading, setOptimizelyLoaded, setOptimizelyError } = useOptimizelyStore();
  const [forceDraftExperiments, setForceDraftExperiments] = useState<boolean>(false);
  const isSupportedPage = useIsSupportedPage(experiments, forceDraftExperiments);

  useEffect(() => {
    setIncludeDraftExperiments();
    if (getIncludeDraftExperiments()) setForceDraftExperiments(true);
    if (!isSupportedPage) {
      return;
    }

    appendExternalScript(scriptUrl, {}, setOptimizelyLoading, setOptimizelyLoaded, setOptimizelyError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSupportedPage]);
};
